<template>
  <div class="lad-filter--order-by-content">
    <slot name="before-range" />

    <div class="wrapper-element-filter">
      <el-select v-model="orderBy" size="mini">
        <el-option
          v-for="v in privateValues"
          :key="v"
          :label="$t(`${base}.order_by.${v}`)"
          :value="v"
        >
          {{ $t(`${base}.order_by.${v}`) }}</el-option
        >
      </el-select>
    </div>

    <slot name="buttons" />
  </div>
</template>

<script>
export default {
  name: 'LadFilterOrderBy',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    value: { type: String, default: '', required: true },
    // eslint-disable-next-line vue/require-valid-default-prop
    values: { type: Array, default: [], required: true },
  },
  data() {
    return {
      base: 'filters',
      privateValues: [],
      orderBy: null,
    }
  },
  watch: {
    values: {
      immediate: true,
      handler(newValue) {
        this.privateValues = newValue
      },
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.orderBy = newValue
      },
    },
    orderBy: {
      immediate: true,
      handler(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
}
</script>

<style lang="scss">
.lad-filter--order-by-content {
  width: auto;

  .el-select {
    display: block;
  }
}
</style>
